import React from "react";

const SubcriptionReportsChild = () => {
  return <div>SubcriptionReportsChild</div>;
};

export default SubcriptionReportsChild;
